import React from 'react';
import { Reveal } from '../common/Reveal';
import { SERVICES } from '../../data/constants';

const serviceIcons = {
  '01': (
    <svg className="w-12 h-12 transition-colors duration-400" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="6" y="14" width="36" height="28" rx="2"/>
      <path d="M6 22h36M18 22v20M30 22v20"/>
      <path d="M16 14V10a2 2 0 012-2h12a2 2 0 012 2v4"/>
    </svg>
  ),
  '02': (
    <svg className="w-12 h-12 transition-colors duration-400" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="6" y="8" width="36" height="32" rx="2"/>
      <path d="M6 20h36M6 32h36M18 8v32M30 8v32"/>
    </svg>
  ),
  '03': (
    <svg className="w-12 h-12 transition-colors duration-400" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 40V20l16-12 16 12v20"/>
      <rect x="18" y="28" width="12" height="12" rx="1"/>
      <path d="M8 20h32"/>
    </svg>
  ),
  '04': (
    <svg className="w-12 h-12 transition-colors duration-400" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="24" cy="24" r="16"/>
      <path d="M24 8v4M24 36v4M8 24h4M36 24h4"/>
      <circle cx="24" cy="24" r="6"/>
    </svg>
  ),
};

export function Services() {
  return (
    <section id="services" className="py-20 md:py-28 px-8 md:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-[600px] mb-16">
          <Reveal>
            <div className="text-[0.68rem] font-normal tracking-[0.35em] uppercase text-nestlent-green mb-3">What We Offer</div>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="font-serif text-[clamp(2.2rem,4vw,3.4rem)] font-light leading-[1.12] text-nestlent-charcoal mb-6">
              Our <em className="italic text-nestlent-green">Services</em>
            </h2>
          </Reveal>
          <Reveal delay={180}>
            <div className="w-12 h-px bg-nestlent-green mb-7" />
          </Reveal>
          <Reveal delay={180}>
            <p className="text-[0.95rem] text-nestlent-grey font-light leading-[1.8] max-w-[480px]">
              From concept to completion, we provide end-to-end architectural and construction services tailored to your vision.
            </p>
          </Reveal>
        </div>

        <Reveal delay={100}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-nestlent-grey-light border-[1.5px] border-nestlent-grey-light">
            {SERVICES.map((s) => (
              <div
                key={s.num}
                className="bg-white p-8 md:p-10 transition-colors duration-400 cursor-default group hover:bg-nestlent-charcoal"
              >
                {/* Number */}
                <div className="font-serif text-[3rem] font-light text-nestlent-grey-light leading-none mb-4 transition-colors duration-400 group-hover:text-white/[0.08]">
                  {s.num}
                </div>
                {/* Icon */}
                <div className="text-nestlent-green mb-6 group-hover:text-nestlent-green-mid">
                  {serviceIcons[s.num]}
                </div>
                {/* Title */}
                <h3 className="font-serif text-[1.3rem] font-normal text-nestlent-charcoal mb-3 transition-colors duration-400 group-hover:text-white">
                  {s.title}
                </h3>
                {/* Text */}
                <p className="text-[0.82rem] font-light leading-[1.7] text-nestlent-grey transition-colors duration-400 group-hover:text-white/60">
                  {s.text}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
